import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from "@angular/platform-browser";
import { FormsModule } from "@angular/forms";
import { HttpModule, XHRBackend } from "@angular/http";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { NgSelectModule } from "@ng-select/ng-select";
import { HeaderComponent } from "./components/header/header.component";
import { HomeComponent } from './pages/home/home.component';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from "../app-routing.module";
@NgModule({
  declarations: [HeaderComponent, HomeComponent],
  imports: [
    CommonModule,
    HttpClientModule,
    AppRoutingModule
  ],
  exports: [
    BrowserModule,
    HeaderComponent,
    HomeComponent,
    HttpClientModule,
    HttpModule,
    FormsModule,
    NgSelectModule,
    FontAwesomeModule,
    BrowserAnimationsModule,
    AppRoutingModule
  ]
})
export class CoreModule { }
